var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", [
    _c(
      "div",
      {
        class: {
          "boss-layout-block-large": _vm.isEnabledForCreateMessageAccordion,
        },
        attrs: { id: "message-register" },
      },
      [
        _vm.isWithdraw
          ? [_vm._m(0)]
          : [
              _vm.canSendMessage
                ? _c("accordion", {
                    ref: "register",
                    attrs: {
                      "is-open": false,
                      disabled: !_vm.isEnabledForCreateMessageAccordion,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "head",
                          fn: function () {
                            return [_vm._v("メッセージ作成")]
                          },
                          proxy: true,
                        },
                        {
                          key: "body",
                          fn: function () {
                            return [
                              _c("entry-message-register", {
                                attrs: {
                                  "entry-ids": _vm.entryIds,
                                  "message-to-applicant":
                                    _vm.messageToApplicant,
                                },
                                on: {
                                  "update:messageToApplicant": function (
                                    $event
                                  ) {
                                    _vm.messageToApplicant = $event
                                  },
                                  "update:message-to-applicant": function (
                                    $event
                                  ) {
                                    _vm.messageToApplicant = $event
                                  },
                                  registered: _vm.registered,
                                },
                              }),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      2302887135
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.isEnabledForCreateMessageAccordion
                ? _c(
                    "div",
                    {
                      staticClass:
                        "boss-annotation-text pega-entry-message-reservation-reserved-label",
                      attrs: { "data-test": "reserved" },
                    },
                    [_vm._v("\n        ※メッセージ予約中\n      ")]
                  )
                : _vm._e(),
            ],
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "boss-layout-block-large" },
      [
        _c("entry-message-history", {
          ref: "entryMessageHistory",
          attrs: { "entry-id": _vm.entryId, "is-withdraw": _vm.isWithdraw },
          on: {
            setMessage: _vm.setMessage,
            setIsMessageReserved: _vm.setIsMessageReserved,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass: "boss-annotation-text font-size-1-1em text-center",
        attrs: { "data-test": "withdraw" },
      },
      [
        _c("div", [
          _vm._v(
            "\n          応募後に退会したため、メッセージ送信ができません。\n        "
          ),
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "\n          レジュメ内のご連絡先に、直接ご連絡ください。\n        "
          ),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }